import PropTypes from 'prop-types';
import React from 'react';
import RevertIcon from '@ux/icon/revert';
import LinkArrow from '@ux/icon/link-arrow';

import NavigationLink from './NavigationLink';
import useIsMobile from '../lib/useIsMobile';

const icons = {
  'revert': RevertIcon,
  'link-arrow': LinkArrow
};

const SidebarFooter = ({ content = [], sidebarNavLinkHandler }) => {
  const isMobile = useIsMobile();
  return (<div className='sidebar-footer'>
    <div className='sidebar-links'>
      {
        content.map(link => {
          const Icon = icons[link.icon];
          if (link.caption && link.href) {
            let linkLabel = link.caption;
            if (link.key === 'mcc:switchToClassicParking') {
              linkLabel = <div className='switch-message'>{ link.caption }<LinkArrow/></div>;
            }
            return <NavigationLink
              key={ link.caption }
              link={ link }
              sidebarNavLinkHandler={ sidebarNavLinkHandler }
              className='sidebar-nav-link'>
              <>
                <span className='nav-link-icon'>{ (!isMobile && Icon) ? <Icon /> : <span /> }</span>
                <span className='nav-link-label'>{ linkLabel }</span>
              </>
            </NavigationLink>;
          }
          return null;
        })
      }
    </div>
  </div>);
};

SidebarFooter.propTypes = {
  content: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  sidebarNavLinkHandler: PropTypes.func
};

export default SidebarFooter;
